import React, { Component, Fragment } from 'react';
import Breakpoint from 'components/layout/Breakpoint.js';

export default class ApplicationFiles extends Component {
    render() {
        const { project, application } = this.props;
        return !project || !application ? null : (
            <Fragment>
                <div className="application-tab">
                    <div className="controls m-t-30">
                        <Breakpoint min="md">
                            <div className="table-title-sub">Документы:</div>
                                    <div>
                                        {!application.files.length && (
                                            <div>
                                                <span className="table-description">Отсутствуют</span>
                                            </div>
                                        )}
                                        {
                                            application.files.map(file => (
                                                <div key={file.url}>
                                                    <a href={file.url} className="table-title-link" target="_blank">
                                                        {file.name}
                                                    </a>
                                                </div>
                                            ))
                                        }
                                    </div>
                        </Breakpoint>
                        <Breakpoint max="md">
                            <div style={{width: '100%'}}>
                                <div className="xs-column sm-application-controls-header">
                                    <span className="table-title-sub m-b-10">Документы:</span>
                                </div>
                                <div className="xs-column">
                                    {!application.files.length && (
                                        <div>
                                            <span className="table-description">Отсутствуют</span>
                                        </div>
                                    )}
                                    {
                                        application.files.map(file => (
                                            <div key={file.url}>
                                                <a href={file.url} className="table-title-link" target="_blank">
                                                    {file.name}
                                                </a>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </Breakpoint>
                    </div>
                </div>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ApplicationFiles.js